import { falconSiteSettingsSchema } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import * as z from "zod";

export const connectFalconOfferNetwork = {
  name: "connectFalconOfferNetwork" as const,
  /** Site audience settings are sent to Falcon at first-time provisioning. */
  input: z.object({ siteSettings: falconSiteSettingsSchema.optional() }),
  output: z.object({ success: z.boolean() }),
};
